import { type MapSettingsExportImageSettingsState } from '~/store/mapSettings/toolsState/exportImageSettings/exportImageSettings.state';

type ConfigType = Readonly<{
  MODE: 'development' | 'production';
  API_URL?: string;
  GOOGLE_APP_ID: string;
  GOOGLE_MAPS_API_KEY: string;
  GOOGLE_PICKER_API_KEY: string;
  INTERCOM_APP_ID: string;
  PUBLIC_MAPS_URL?: string;
  RECAPTCHA_KEY: string;
  SHOW_SIGNUP: boolean;
  LEGACY_LOGIN_URL: string;
  GOOGLE_OAUTH_CLIENT_ID: string;
  MS_OAUTH_CLIENT_ID: string;
  SOCKET_URL?: string;

  ENABLE_MIGRATE_ALL: boolean;
  ENABLE_MIGRATION: boolean;
  ENABLE_COMPLETE_MIGRATION: boolean;
  ENABLE_CHARTS: boolean;
  ENABLE_MAPTIVE_OPTIMISED_TERRITORIES: boolean;
  ENABLE_OPTIMIZED_TERRITORY_AUTO_NAME_BUILDER: boolean;
  ENABLE_OPTIMIZED_TERRITORY_CONFIG_EXPORT: boolean;
  ENABLE_PDF_EXPORT: boolean;
  ENABLE_DATA_LAYERS: boolean;
  ENABLE_FILL_GROUPS_FOR_CUSTOM_BOUNDARIES?: boolean;
  ENABLE_FOURSQUARE_POI_PROVIDER?: boolean;

  ////////////////////////////
  // DEBUG & DEV ONLY FLAGS
  ////////////////////////////

  // Use local proxy for AGS API requests (for development purposes only)
  AGS_API_KEY?: string;

  // Simulate the state of the export image settings
  EXPORT_IMAGE_SETTINGS?: Partial<MapSettingsExportImageSettingsState>;

  // For testing / automation purposes only.
  HARDCODED_CREDENTIALS?: {
    email: string;
    password: string;
  };

  SIMULATE_APPLE_MOBILE_DEVICE?: boolean;
  HIDE_GOOGLE_MAP?: boolean;

  // Shows a button in the export report preview that opens the PDF report print page locally
  ENABLE_DEV_PDF_REPORT_PRINT_PAGE: boolean;
}>;

const defaultConfig: ConfigType = {
  MODE: 'development',
  GOOGLE_APP_ID: '143084119377',
  GOOGLE_MAPS_API_KEY: 'AIzaSyAbt4SDtPzrsVwCE5pLvL5iPEHyjKZICWI',
  GOOGLE_PICKER_API_KEY: 'AIzaSyCiYCE-dyhpB3cpG_oi2YHMGkVW7lhEsEw',
  INTERCOM_APP_ID: 'odvc6gwb',
  RECAPTCHA_KEY: '6Ld8yUojAAAAAJIGu33P9O52_w9yY6l9ewwrNkB8',
  SHOW_SIGNUP: true,
  LEGACY_LOGIN_URL: 'https://fortress.maptive.com/ver4/login.php',
  GOOGLE_OAUTH_CLIENT_ID: '143084119377-aleft4822rcfjo3bfdhp6sv2nnjr91qm.apps.googleusercontent.com',
  MS_OAUTH_CLIENT_ID: 'c3a6138c-071a-4a5e-93a7-e3aee005f8b0',

  ENABLE_MIGRATE_ALL: false,
  ENABLE_MIGRATION: true,
  ENABLE_COMPLETE_MIGRATION: false,
  ENABLE_CHARTS: true,
  ENABLE_MAPTIVE_OPTIMISED_TERRITORIES: false,
  ENABLE_OPTIMIZED_TERRITORY_AUTO_NAME_BUILDER: false,
  ENABLE_OPTIMIZED_TERRITORY_CONFIG_EXPORT: false,
  ENABLE_PDF_EXPORT: false,
  ENABLE_DATA_LAYERS: false,
  ENABLE_FOURSQUARE_POI_PROVIDER: false,
  ENABLE_DEV_PDF_REPORT_PRINT_PAGE: false,
};

const EnvConfigLocalStorageKey = 'ENV_CONFIG';

const parseLocalStorageConfig = (jsonConfig: string) => {
  try {
    return JSON.parse(jsonConfig);
  }
  catch (e) {
    console.error('Malformed JSON in localStorage.ENV_CONFIG.', e);
    return {};
  }
};

export const writeLocalStorageConfig = (jsonConfig: MaybePartial<ConfigType>) => {
  if (typeof localStorage === 'undefined') {
    return;
  }

  localStorage.setItem(EnvConfigLocalStorageKey, JSON.stringify(jsonConfig));
};

export const getLocalStorageEnvironmentConfig = () => {
  if (typeof localStorage === 'undefined') {
    return {};
  }

  const localStorageConfig = localStorage.getItem(EnvConfigLocalStorageKey) ?? '{}';

  return parseLocalStorageConfig(localStorageConfig);
};

export const CONFIG: ConfigType = {
  ...defaultConfig,
  ...(globalThis as any)?._envConfig,
  ...getLocalStorageEnvironmentConfig(),
};

export const reloadConfig = () => {
  for (const key of Object.keys(CONFIG)) {
    delete (CONFIG as any)[key];
  }

  Object.assign(CONFIG, {
    ...defaultConfig,
    ...(globalThis as any)?._envConfig,
    ...getLocalStorageEnvironmentConfig(),
  });
};
